export enum ProductTypeEnum {
  PRODUCTS = 'products',
  ACCESSORIES = 'accessories',
  BUNDLE = 'bundle',
  REPAIR_PACKAGE = 'repair package',
  EMPTY = ''
}

export enum ProductAccessoryTypeEnum {
  ACCESSORY = 'ACCESSORY',
  DETACHED_PIECE = 'DETACHED_PIECE'
}
